module.exports = __webpack_public_path__ + "img/undraw_cloud_sync_2aph.504bbdc3.svg";